import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';

export interface PlayList {
	id: number;
	title: string;
	thumbnail: string;
	streaming: boolean;
	watched: boolean;
}

@Component({
	selector: 'app-playlist',
	templateUrl: './playlist.component.html',
	styleUrls: ['./playlist.component.scss']
})
export class PlaylistComponent implements OnInit {


	@Input() playList: Array<PlayList>;
	@Output() emitData: any = new EventEmitter();
	constructor(
		public locale: LocaleService,
	) { }

	ngOnInit(): void {
	}

	selectData(data) {
		if (navigator.onLine) {
			this.playList.forEach((event: any) => {
				event.streaming = false;
			});
			data.streaming = true;
			this.emitData.emit(data);
		}
	}

}
